import BaseModel from './BaseModel'

export default class StationModel extends BaseModel {
    get schema() {
        return {
            id: ['id', undefined, value => value],
            name: ['name', undefined, value => value],
            city: ['city', undefined, value => value],
            coordinates: ['coordinates', undefined, value => {
                if (typeof (value) === 'string') {
                    return value.split(',')
                }
            }],
            worktime: ['worktime', undefined],
            phone: ['phone', undefined],
            photolink: ['photolink', undefined, value => value], // photolink
        }
    };

    static attributeLabels = {
        id: 'ID',
        name: 'Название',
        city: 'Город',
        coordinates: 'Координаты',
        worktime: 'Время работы',
        phone: 'Телефон',
    }
}
